module.exports = __webpack_public_path__ + "img/corner-up-left.1de7e2c0.svg";